import React from 'react'
import FontAwesome from 'react-fontawesome'

const IconComponent = (props) => {
  const { icon, text, className, onClick } = props

  return (
    <span onClick={onClick}>
      <FontAwesome name={icon} className={className} /> {text}
    </span>
  )
}

export default IconComponent
